import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClientRoutingModule } from './client-routing.module';
import { ClientComponent } from './client/client.component';
import { ClientsComponent } from './clients/clients.component';
import { SharedModule } from '@app-shared/shared.module';
import { StatsListItemComponent } from '@app-shared/components/stats-list-item/stats-list-item.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
	declarations: [ClientComponent, ClientsComponent],
	imports: [CommonModule, ClientRoutingModule, SharedModule, MatProgressSpinnerModule]
})
export class ClientModule {}
